/**
 * Measurement hint badge showing oversize % or remaining length warning.
 */

import { cn } from '@/lib/utils';
import type { HintInfo } from '@/workflows/vascular/common/catalog';

interface MeasurementHintProps {
    hint: HintInfo;
}

export function MeasurementHint({ hint }: MeasurementHintProps) {
    if (!hint) return null;

    if (hint.type === 'oversize') {
        // Deliberately colorless: the value must not carry any clinical interpretation
        return (
            <span className="inline-flex items-center rounded px-1 py-0.5 text-[9px] font-mono font-semibold bg-muted text-muted-foreground">
                {hint.percent > 0 ? '+' : ''}
                {hint.percent}%
            </span>
        );
    }

    if (hint.type === 'remaining_length') {
        return (
            <span
                className={cn(
                    'inline-flex items-center rounded px-1 py-0.5 text-[9px] font-mono font-semibold',
                    hint.tooLong ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
                )}
            >
                {hint.tooLong ? 'Too Long' : 'OK'}
                <span className="ml-0.5 text-[8px] opacity-75">
                    ({hint.delta > 0 ? '+' : ''}
                    {hint.delta}mm)
                </span>
            </span>
        );
    }

    return null;
}
